import React from "react";
import { Link } from "react-router-dom";

import { AppButton } from "../utils";
import curvePath from "../assets/curvePath.svg";
import drishtiLogo from "../assets/drishtiLogo.svg";
import { Linkedin, Instagram, Twitter, Youtube } from "./ButtonLinks";

function Footer({ support }) {
  return (
    <>
      {support && (
        <div className="p-8 px-4 max-w-sm md:max-w-2xl lg:max-w-7xl mx-auto">
          <div className="p-8 text-center md: text:left  w-full rounded-tl-3xl rounded-br-3xl bg-mix-900 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 flex-row items-center">
            <div className="lg:col-span-2 font-montserrat">
              <h3 className="font-semibold px-12 text-mix-400 text-xl md:text-2xl lg:text-3xl font-josefin">
                Support our work
              </h3>

              <p className="text-base sm:text-lg font-montserrat px-4">
                <br />
                "No act of kindness , no matter how small is ever wasted."
                <span className="block ">
                  Please support our future events and donation drive. Every
                  little donation counts in times of need.
                </span>
              </p>
            </div>
            <div className="p-8 flex justify-center items-center w-full">
              <Link to="/donate">
                <AppButton text="Donate" />
              </Link>
            </div>
          </div>
        </div>
      )}

      <img src={curvePath} alt="curve path" className="w-full mt-12" />
      <div className="max-w-sm md:max-w-2xl lg:max-w-7xl mx-auto mt-16 md:mt-12 lg:mt-20">
        <div className="font-montserrat">
          <h1 className="text-center font-semibold text-mix-400 text-2xl md:text-3xl lg:text-4xl">
            Signup to our newsletter
          </h1>
          <p className="text-sm sm:text-base mt-4 sm:mt-8 text-center italic">
            Stay connected with us in our journey.
          </p>
          <div className="mt-8 sm:mt-12 max-w-xl mx-auto">
            <form className="text-center flex items-center">
              <input
                type="text"
                placeholder="Enter your email id"
                className="w-full border-none rounded-full outline-none focus:ring-2 focus:outline-none focus:ring-mix-200 px-4 mr-4 h-10 text-sm sm:text-lg"
              />
              <AppButton text="Submit" />
            </form>
          </div>
          <div className="mt-8 sm:mt-12 hidden sm:flex sm:items-center sm:justify-between">
            <Link to="/">
              <img src={drishtiLogo} alt="drishti logo" />
            </Link>
            <Link to="/about">
              <h5 className="font-semibold md:text-lg lg:text-xl text-mix-500 hover:text-mix-200 cursor-pointer">
                About Us
              </h5>
            </Link>
            <Link to="/events-listing">
              <h5 className="font-semibold md:text-lg lg:text-xl text-mix-500 hover:text-mix-200 cursor-pointer">
                Events
              </h5>
            </Link>
            <h5 className="font-semibold md:text-lg lg:text-xl text-mix-500 hover:text-mix-200 cursor-pointer">
              <Link to="/donate">Donate</Link>
            </h5>

            <div className="flex justify-between items-center  lg:w-60">
              <Linkedin size={30} />
              <Instagram size={30} />
              <Youtube size={30} />
              <Twitter size={30} />
            </div>
          </div>
          <div className="mt-5 md:mt-8 lg:mt-10">
            {" "}
            <hr style={{ color: "grey", height: 10 }} />{" "}
          </div>
          <div className="flex justify-between mt-10">
            <div className="flex justify-between px-2 w-1/5">
              <p className="cursor-pointer text-gray-400 hover:text-gray-700 text-xs">
                Privacy Policy
              </p>
              <p className="cursor-pointer text-gray-400 hover:text-gray-700 text-xs">
                Terms & Conditions
              </p>
            </div>
            <div className="px-4">
              <p className="text-xs md:text-base lg:text-base">
                © 2021 - Drishti All Right Reserved
              </p>
            </div>
          </div>
          <p>
            <br />
            <br />
          </p>
        </div>
      </div>
    </>
  );
}

export default Footer;
